import { TourConfig } from '../models/tour-config.model';
import {
  EMPLOYEE_ADD_CONTEXTUAL_TOUR,
  FIRST_EMPLOYEE_ONBOARDING_TOUR,
} from './employee-tutorial.config';
import {
  DEPARTMENT_ADD_CONTEXTUAL_TOUR,
  FIRST_DEPARTMENT_ONBOARDING_TOUR,
} from './department-tutorial.config';
import {
  SKILL_ADD_CONTEXTUAL_TOUR,
  ADD_SKILLS_ONBOARDING_TOUR,
} from './skills-tutorial.config';
import { TERMINAL_ADD_CONTEXTUAL_TOUR } from './terminal-tutorial.config';
import { COMPANY_INFO_ONBOARDING_TOUR } from './settings-tutorial.config';
import { MENTOR_ENTRY_TOUR } from './mentor-entry-tour.config';
import { MENTOR_SINGLE_SHIFT_TOUR } from './mentor-single-shift-tour.config';
import { MENTOR_PATTERN_TOUR } from './mentor-pattern-tour.config';
import { MENTOR_EXPLORE_TOUR } from './mentor-explore-tour.config';
import { MENTOR_REUNITE_TOUR } from './mentor-reunite-tour.config';
import { MENTOR_ENDGAME_TOUR } from './mentor-endgame-tour.config';
import { TIME_RECORDING_ONBOARDING_TOUR } from './time-recording-tutorial.config';
import { TASKS_ONBOARDING_TOUR } from './tasks-tutorial.config';
import { AUTO_SUGGEST_HELP_TOUR } from './auto-suggest-tutorial.config';
import { ADD_SHIFT_HELP_TOUR } from './add-shift-help-tour.config';
import { SHIFT_PLAN_ANALYSIS_HELP_TOUR } from './shift-plan-analysis-help-tour.config';
import { SHIFT_APPLICATIONS_INBOX_HELP_TOUR } from './shift-applications-inbox-help-tour.config';
import { BULK_DELETE_SHIFTS_HELP_TOUR } from './bulk-delete-shifts-help-tour.config';
import { BULK_PUBLISH_SHIFTS_HELP_TOUR } from './bulk-publish-shifts-help-tour.config';
import { UNPUBLISH_WEEK_HELP_TOUR } from './unpublish-week-help-tour.config';
import { DELETE_PATTERN_HELP_TOUR } from './delete-pattern-help-tour.config';
import { CLEANUP_PLANNING_HELP_TOUR } from './cleanup-planning-help-tour.config';
import { CHANGE_REQUESTS_HELP_TOUR } from './change-requests-help-tour.config';
import { PUBLISH_OPEN_SHIFTS_HELP_TOUR } from './publish-open-shifts-dialog-help-tour.config';
import { WORK_SHIFT_REPORT_HELP_TOUR } from './work-shift-report-tutorial.config';
import { TIME_RECORDING_REPORT_HELP_TOUR } from './time-recording-report-tutorial.config';
import { SHOW_TIME_RECORDING_DETAILS_HELP_TOUR } from './show-time-recording-details-help-tour.config';
import { TEMPLATES_HELP_TOUR } from './templates-tutorial.config';
import { STAFFING_BEDARFSPLAN_HELP_TOUR } from './staffing-bedarfsplan-help-tour.config';
import { SHIFT_ASSIGNMENT_HELP_TOUR } from './shift-assignment-help-tour.config';
import { STAFFING_WIZARD_HELP_TOUR } from './staffing-wizard-help-tour.config';
import { REQUIREMENT_DETAILS_HELP_TOUR } from './requirement-details-help-tour.config';
import { AVAILABILITY_CALENDAR_HELP_TOUR } from './availability-calendar-help-tour.config';
import { AVAILABILITY_ADD_HELP_TOUR } from './availability-add-help-tour.config';
import { EMPLOYEE_ADD_HELP_TOUR } from './employee-add-help-tour.config';
import { PERMISSIONS_HELP_TOUR } from './permissions-help-tour.config';
import { EMPLOYEE_LIST_HELP_TOUR } from './employee-list-help-tour.config';
import { ORG_DEPARTMENTS_HELP_TOUR } from './org-departments-help-tour.config';
import { ORG_SKILLS_HELP_TOUR } from './org-skills-help-tour.config';
import { ASSIGN_EMPLOYEES_HELP_TOUR } from './assign-employees-dialog-help-tour.config';
import { DEPARTMENT_ADD_HELP_TOUR } from './department-add-help-tour.config';
import { SKILL_ADD_HELP_TOUR } from './skill-add-help-tour.config';
import { ABSENCE_CALENDAR_HELP_TOUR } from './absence-calendar-help-tour.config';
import { ABSENCE_ADD_HELP_TOUR } from './absence-add-help-tour.config';
import { ABSENCE_ACCEPT_HELP_TOUR } from './absence-accept-help-tour.config';
import { EMPLOYEE_FILE_HELP_TOUR } from './employee-file-help-tour.config';
import { EMPLOYEE_FILE_ADD_HELP_TOUR } from './employee-file-add-help-tour.config';
import { SETTINGS_GENERAL_HELP_TOUR } from './settings-general-help-tour.config';
import { SETTINGS_HOLIDAYS_HELP_TOUR } from './settings-holidays-help-tour.config';
import { SETTINGS_SHIFT_HELP_TOUR } from './settings-shift-help-tour.config';
import { SETTINGS_TIME_TRACKING_HELP_TOUR } from './settings-time-tracking-help-tour.config';
import { SETTINGS_TERMINAL_HELP_TOUR } from './settings-terminal-help-tour.config';
import { DASHBOARD_HELP_TOUR } from './dashboard-help-tour.config';
// Aufgaben-Modul: neun ?-Hilfen ueber alle Flaechen (B-10 Folgeausbau).
import { TASKS_OVERVIEW_HELP_TOUR } from './tasks-overview-help-tour.config';
import { TASK_SHEET_HELP_TOUR } from './task-sheet-help-tour.config';
import { TASK_PROJECT_SHEET_HELP_TOUR } from './task-project-sheet-help-tour.config';
import { TASK_PROJECT_OVERVIEW_HELP_TOUR } from './task-project-overview-help-tour.config';
import { TASKS_PROJECTS_VIEW_HELP_TOUR } from './tasks-projects-view-help-tour.config';
import { TASK_THROUGHPUT_HELP_TOUR } from './task-throughput-help-tour.config';
import { SETTINGS_TASKS_HELP_TOUR } from './settings-tasks-help-tour.config';
import { TASK_CHECKLIST_HELP_TOUR } from './task-checklist-help-tour.config';
import { TASK_DETAIL_HELP_TOUR } from './task-detail-help-tour.config';
import { TASK_ROUTINES_HELP_TOUR } from './task-routines-help-tour.config';
import { TASK_ROUTINE_EDITOR_HELP_TOUR } from './task-routine-editor-help-tour.config';
import { TASK_LAGE_HELP_TOUR } from './task-lage-help-tour.config';
import { TASK_NACHWEISE_HELP_TOUR } from './task-nachweise-help-tour.config';
import { MY_TASKS_HELP_TOUR } from './my-tasks-help-tour.config';
import { TASK_COMPLETE_SHEET_HELP_TOUR } from './task-complete-sheet-help-tour.config';
// Self-Service-Demo: einmaliger, automatischer Verkaufsrundgang (nie ausserhalb einer Demo-Session).
import { DEMO_QUICK_TOUR } from './demo-quick-tour.config';
// Freiwillige "Mehr entdecken"-Kette nach Station 3 (Mitarbeiter → Zeiterfassung → Abwesenheit).
import { DEMO_DISCOVER_EMPLOYEE } from './demo-discover-employee.config';
import { DEMO_DISCOVER_TIME_RECORDING } from './demo-discover-time-recording.config';
import { DEMO_DISCOVER_ABSENCE } from './demo-discover-absence.config';

export {
  EMPLOYEE_ADD_CONTEXTUAL_TOUR,
  FIRST_EMPLOYEE_ONBOARDING_TOUR,
} from './employee-tutorial.config';
export {
  DEPARTMENT_ADD_CONTEXTUAL_TOUR,
  FIRST_DEPARTMENT_ONBOARDING_TOUR,
} from './department-tutorial.config';
export {
  SKILL_ADD_CONTEXTUAL_TOUR,
  ADD_SKILLS_ONBOARDING_TOUR,
} from './skills-tutorial.config';
export { TERMINAL_ADD_CONTEXTUAL_TOUR } from './terminal-tutorial.config';
export { COMPANY_INFO_ONBOARDING_TOUR } from './settings-tutorial.config';
export { MENTOR_ENTRY_TOUR } from './mentor-entry-tour.config';
export { MENTOR_SINGLE_SHIFT_TOUR } from './mentor-single-shift-tour.config';
export { MENTOR_PATTERN_TOUR } from './mentor-pattern-tour.config';
export { MENTOR_EXPLORE_TOUR } from './mentor-explore-tour.config';
export { MENTOR_REUNITE_TOUR } from './mentor-reunite-tour.config';
export { MENTOR_ENDGAME_TOUR } from './mentor-endgame-tour.config';
export { TIME_RECORDING_ONBOARDING_TOUR } from './time-recording-tutorial.config';
export { TASKS_ONBOARDING_TOUR } from './tasks-tutorial.config';
export { AUTO_SUGGEST_HELP_TOUR } from './auto-suggest-tutorial.config';
export { ADD_SHIFT_HELP_TOUR } from './add-shift-help-tour.config';
export { SHIFT_PLAN_ANALYSIS_HELP_TOUR } from './shift-plan-analysis-help-tour.config';
export { SHIFT_APPLICATIONS_INBOX_HELP_TOUR } from './shift-applications-inbox-help-tour.config';
export { BULK_DELETE_SHIFTS_HELP_TOUR } from './bulk-delete-shifts-help-tour.config';
export { BULK_PUBLISH_SHIFTS_HELP_TOUR } from './bulk-publish-shifts-help-tour.config';
export { UNPUBLISH_WEEK_HELP_TOUR } from './unpublish-week-help-tour.config';
export { DELETE_PATTERN_HELP_TOUR } from './delete-pattern-help-tour.config';
export { CLEANUP_PLANNING_HELP_TOUR } from './cleanup-planning-help-tour.config';
export { CHANGE_REQUESTS_HELP_TOUR } from './change-requests-help-tour.config';
export { PUBLISH_OPEN_SHIFTS_HELP_TOUR } from './publish-open-shifts-dialog-help-tour.config';
export { WORK_SHIFT_REPORT_HELP_TOUR } from './work-shift-report-tutorial.config';
export { TIME_RECORDING_REPORT_HELP_TOUR } from './time-recording-report-tutorial.config';
export { SHOW_TIME_RECORDING_DETAILS_HELP_TOUR } from './show-time-recording-details-help-tour.config';
export { TEMPLATES_HELP_TOUR } from './templates-tutorial.config';
export { STAFFING_BEDARFSPLAN_HELP_TOUR } from './staffing-bedarfsplan-help-tour.config';
export { SHIFT_ASSIGNMENT_HELP_TOUR } from './shift-assignment-help-tour.config';
export { STAFFING_WIZARD_HELP_TOUR } from './staffing-wizard-help-tour.config';
export { REQUIREMENT_DETAILS_HELP_TOUR } from './requirement-details-help-tour.config';
export { AVAILABILITY_CALENDAR_HELP_TOUR } from './availability-calendar-help-tour.config';
export { AVAILABILITY_ADD_HELP_TOUR } from './availability-add-help-tour.config';
export { EMPLOYEE_ADD_HELP_TOUR } from './employee-add-help-tour.config';
export { PERMISSIONS_HELP_TOUR } from './permissions-help-tour.config';
export { EMPLOYEE_LIST_HELP_TOUR } from './employee-list-help-tour.config';
export { ORG_DEPARTMENTS_HELP_TOUR } from './org-departments-help-tour.config';
export { ORG_SKILLS_HELP_TOUR } from './org-skills-help-tour.config';
export { ASSIGN_EMPLOYEES_HELP_TOUR } from './assign-employees-dialog-help-tour.config';
export { DEPARTMENT_ADD_HELP_TOUR } from './department-add-help-tour.config';
export { SKILL_ADD_HELP_TOUR } from './skill-add-help-tour.config';
export { ABSENCE_CALENDAR_HELP_TOUR } from './absence-calendar-help-tour.config';
export { ABSENCE_ADD_HELP_TOUR } from './absence-add-help-tour.config';
export { ABSENCE_ACCEPT_HELP_TOUR } from './absence-accept-help-tour.config';
export { EMPLOYEE_FILE_HELP_TOUR } from './employee-file-help-tour.config';
export { EMPLOYEE_FILE_ADD_HELP_TOUR } from './employee-file-add-help-tour.config';
export { SETTINGS_GENERAL_HELP_TOUR } from './settings-general-help-tour.config';
export { SETTINGS_HOLIDAYS_HELP_TOUR } from './settings-holidays-help-tour.config';
export { SETTINGS_SHIFT_HELP_TOUR } from './settings-shift-help-tour.config';
export { SETTINGS_TIME_TRACKING_HELP_TOUR } from './settings-time-tracking-help-tour.config';
export { SETTINGS_TERMINAL_HELP_TOUR } from './settings-terminal-help-tour.config';
export { DASHBOARD_HELP_TOUR } from './dashboard-help-tour.config';
export { TASKS_OVERVIEW_HELP_TOUR } from './tasks-overview-help-tour.config';
export { TASK_SHEET_HELP_TOUR } from './task-sheet-help-tour.config';
export { TASK_PROJECT_SHEET_HELP_TOUR } from './task-project-sheet-help-tour.config';
export { TASK_PROJECT_OVERVIEW_HELP_TOUR } from './task-project-overview-help-tour.config';
export { TASKS_PROJECTS_VIEW_HELP_TOUR } from './tasks-projects-view-help-tour.config';
export { TASK_THROUGHPUT_HELP_TOUR } from './task-throughput-help-tour.config';
export { SETTINGS_TASKS_HELP_TOUR } from './settings-tasks-help-tour.config';
export { TASK_CHECKLIST_HELP_TOUR } from './task-checklist-help-tour.config';
export { TASK_DETAIL_HELP_TOUR } from './task-detail-help-tour.config';
export { TASK_ROUTINES_HELP_TOUR } from './task-routines-help-tour.config';
export { TASK_ROUTINE_EDITOR_HELP_TOUR } from './task-routine-editor-help-tour.config';
export { TASK_LAGE_HELP_TOUR } from './task-lage-help-tour.config';
export { TASK_NACHWEISE_HELP_TOUR } from './task-nachweise-help-tour.config';
export { MY_TASKS_HELP_TOUR } from './my-tasks-help-tour.config';
export { TASK_COMPLETE_SHEET_HELP_TOUR } from './task-complete-sheet-help-tour.config';
export { DEMO_QUICK_TOUR } from './demo-quick-tour.config';
export { DEMO_DISCOVER_EMPLOYEE } from './demo-discover-employee.config';
export { DEMO_DISCOVER_TIME_RECORDING } from './demo-discover-time-recording.config';
export { DEMO_DISCOVER_ABSENCE } from './demo-discover-absence.config';

/**
 * Zentrale Liste aller verfuegbaren Touren. Wird vom APP_INITIALIZER in
 * `main.ts` geladen und via `TourRegistry.register()` validiert. Ein
 * invalider Anchor bricht den Dev-Build (Fail-Fast).
 *
 * Reihenfolge nach Priority (niedrige Zahl = frueher) fuer den
 * Onboarding-Funnel — verbindlich identisch zur mainOrder im
 * Onboarding-Checklist-FAB:
 * 1. CompanyInfo        (priority 10) — Basis
 * 2. FirstDepartment    (priority 20) — Struktur
 * 3. AddSkills          (priority 30) — Qualifikationen
 * 4. FirstEmployee      (priority 40) — Personen
 * 5. MentorEntry        (priority 50) — Planungs-Reise (ersetzt die alten
 *    ShiftPlanning/StaffingManagement-Touren, die entfernt wurden)
 * 6. TimeRecording      (priority 60) — Zeiten erfassen / korrigieren
 * 7. Tasks              (priority 70) — erste Aufgabe anlegen & zuweisen
 *
 * TourFeature.Welcome ist bewusst NICHT dabei: die Legacy-Config hat keine
 * Tour-Steps (nur einen Checklist-Header). Das Welcome-Feature bleibt in
 * der FAB-Checklist sichtbar, ohne eigene Guided-Tour.
 */
export const ALL_TOUR_CONFIGS: TourConfig[] = [
  // Grosse Welcome-/Setup-Tours (sequentieller Funnel, FirstVisit-faehig).
  // Reihenfolge matcht die UI-Checklist und die Priority-Funnel-Ordnung.
  COMPANY_INFO_ONBOARDING_TOUR,
  FIRST_DEPARTMENT_ONBOARDING_TOUR,
  ADD_SKILLS_ONBOARDING_TOUR,
  FIRST_EMPLOYEE_ONBOARDING_TOUR,
  // Planning-Onboarding "Mentor" — belegt den Planungs-Slot (priority 50) im
  // Setup-Funnel. Die alten ShiftPlanning/StaffingManagement-Touren wurden
  // vollstaendig entfernt (lehrten das abgeloeste Zwei-Schritte-Modell).
  MENTOR_ENTRY_TOUR,
  TIME_RECORDING_ONBOARDING_TOUR,
  // Aufgaben (B-10) — siebter und letzter Setup-Schritt. Voraussetzungen im
  // Graphen: first-department + add-skills (die Zuweisungsziele).
  TASKS_ONBOARDING_TOUR,

  // Mentor-Zweig-Touren (via W1 actions[].startTour gestartet; category
  // 'feature-discovery' = gefuehrter Flow, NICHT help-mode, und nicht im
  // Setup-Counter). R1/R2 (Reunite/Endgame) folgen in 6e.
  MENTOR_SINGLE_SHIFT_TOUR,
  MENTOR_PATTERN_TOUR,
  MENTOR_EXPLORE_TOUR,
  MENTOR_REUNITE_TOUR,
  MENTOR_ENDGAME_TOUR,

  // Kontextuelle In-Dialog-Tours (manuell via Hilfe-Button)
  EMPLOYEE_ADD_CONTEXTUAL_TOUR,
  DEPARTMENT_ADD_CONTEXTUAL_TOUR,
  SKILL_ADD_CONTEXTUAL_TOUR,
  TERMINAL_ADD_CONTEXTUAL_TOUR,
  AUTO_SUGGEST_HELP_TOUR,
  ADD_SHIFT_HELP_TOUR,
  SHIFT_PLAN_ANALYSIS_HELP_TOUR,
  SHIFT_APPLICATIONS_INBOX_HELP_TOUR,
  BULK_DELETE_SHIFTS_HELP_TOUR,
  BULK_PUBLISH_SHIFTS_HELP_TOUR,
  // Planning-Folgen-Hilfen (Mentor AP-8, §7a)
  UNPUBLISH_WEEK_HELP_TOUR,
  DELETE_PATTERN_HELP_TOUR,
  CLEANUP_PLANNING_HELP_TOUR,
  CHANGE_REQUESTS_HELP_TOUR,
  PUBLISH_OPEN_SHIFTS_HELP_TOUR,
  WORK_SHIFT_REPORT_HELP_TOUR,
  TIME_RECORDING_REPORT_HELP_TOUR,
  SHOW_TIME_RECORDING_DETAILS_HELP_TOUR,
  TEMPLATES_HELP_TOUR,
  STAFFING_BEDARFSPLAN_HELP_TOUR,
  SHIFT_ASSIGNMENT_HELP_TOUR,
  STAFFING_WIZARD_HELP_TOUR,
  REQUIREMENT_DETAILS_HELP_TOUR,
  AVAILABILITY_CALENDAR_HELP_TOUR,
  AVAILABILITY_ADD_HELP_TOUR,
  EMPLOYEE_ADD_HELP_TOUR,
  PERMISSIONS_HELP_TOUR,
  EMPLOYEE_LIST_HELP_TOUR,
  ORG_DEPARTMENTS_HELP_TOUR,
  ORG_SKILLS_HELP_TOUR,
  ASSIGN_EMPLOYEES_HELP_TOUR,
  DEPARTMENT_ADD_HELP_TOUR,
  SKILL_ADD_HELP_TOUR,
  ABSENCE_CALENDAR_HELP_TOUR,
  ABSENCE_ADD_HELP_TOUR,
  ABSENCE_ACCEPT_HELP_TOUR,
  EMPLOYEE_FILE_HELP_TOUR,
  EMPLOYEE_FILE_ADD_HELP_TOUR,
  SETTINGS_GENERAL_HELP_TOUR,
  SETTINGS_HOLIDAYS_HELP_TOUR,
  SETTINGS_SHIFT_HELP_TOUR,
  SETTINGS_TIME_TRACKING_HELP_TOUR,
  SETTINGS_TERMINAL_HELP_TOUR,
  DASHBOARD_HELP_TOUR,

  // Aufgaben-Modul — neun ?-Hilfen, eine je Flaeche. Bewusst OHNE
  // `requiredPermissions`: sie starten ausschliesslich ueber einen ?-Knopf,
  // der ohnehin nur dort haengt, wo der Nutzer schon steht. Ein Rechte-Gate
  // wuerde sie — wie die Setup-Tour `Tasks` — fail-closed unsichtbar machen,
  // solange das Backend keinen `Tasks`-Permission-Block liefert.
  TASKS_OVERVIEW_HELP_TOUR,
  TASK_SHEET_HELP_TOUR,
  TASK_PROJECT_SHEET_HELP_TOUR,
  TASK_PROJECT_OVERVIEW_HELP_TOUR,
  TASKS_PROJECTS_VIEW_HELP_TOUR,
  TASK_THROUGHPUT_HELP_TOUR,
  SETTINGS_TASKS_HELP_TOUR,
  TASK_CHECKLIST_HELP_TOUR,
  TASK_DETAIL_HELP_TOUR,
  TASK_ROUTINES_HELP_TOUR,
  TASK_ROUTINE_EDITOR_HELP_TOUR,
  TASK_LAGE_HELP_TOUR,
  TASK_NACHWEISE_HELP_TOUR,
  MY_TASKS_HELP_TOUR,
  TASK_COMPLETE_SHEET_HELP_TOUR,

  // Self-Service-Demo: manueller Trigger (TourTrigger.Manual), Start laeuft
  // ausschliesslich ueber DemoQuickTourService.maybeShow() — NICHT ueber den
  // FirstVisit-Funnel oben, der hat kein "ist Demo"-Praedikat.
  DEMO_QUICK_TOUR,
  // Freiwillige "Mehr entdecken"-Kette nach Station 3, verkettet via
  // actions[].startTour — startet nie eigenstaendig.
  DEMO_DISCOVER_EMPLOYEE,
  DEMO_DISCOVER_TIME_RECORDING,
  DEMO_DISCOVER_ABSENCE,
];
